<template>
<div>

  <header>
    <div class="header container column align-items-center justify-content-center">
      <div class="block text-center">
        <img src="@/assets/img/logos/logo-black.svg" class="logo" alt="Minds">
        <p>
          Styleguide EAD Minds
        </p>
        <small>Progressive web application</small>
      </div>
    </div>
  </header>

</div>
</template>

<script>
export default {
  name: 'topo',
}
</script>

<style lang="scss" scoped>
.header {
    min-height: calc(100vh - 100px);
    width: 100%;
    .block {
        width: 600px;
        max-width: 90%;
        text-align: center;
        img {
            width: 400px;
            max-width: 90%;
            padding-bottom: 20px;
        }
        small {
          opacity: .5;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/topo/index.vue